export const CHAT_TIME_ZONE = 'UTC';

export const formatChatTime = (dateString: string): string => {
  try {
    const d = new Date(dateString);
    return d.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: CHAT_TIME_ZONE,
    });
  } catch {
    return '';
  }
};

export const formatChatDate = (dateString: string): string => {
  try {
    const d = new Date(dateString);
    return d.toLocaleDateString([], {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: CHAT_TIME_ZONE,
    });
  } catch {
    return '';
  }
};
